import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { MediaGenre, Show } from '../types/types';
import theme from '@shared/themes/darkTheme';
import { GridCard } from './GridCard';
export const ProgrammesGrid = ({
  mediaGenres,
  selectedCategory,
  handleBackClick,
  onProgrammeClick,
}: {
  mediaGenres: MediaGenre[];
  selectedCategory: string;
  handleBackClick: () => void;
  onProgrammeClick: (programme: Show) => Promise<void>;
}) => {
  const currentGenreData = mediaGenres.find(genre => genre.name === selectedCategory);

  if (!currentGenreData || currentGenreData.shows.length === 0) {
    return (
      <Box sx={{ width: '100%', mt: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <IconButton onClick={handleBackClick} sx={{ mr: 2 }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            {selectedCategory} Shows
          </Typography>
        </Box>
        <Typography variant="body1" color={theme.palette.text.secondary} sx={{ textAlign: 'center', py: 4 }}>
          No shows available for this genre yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', mt: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton onClick={handleBackClick} sx={{ mr: 2 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          {currentGenreData.name} Shows
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(auto-fill, minmax(250px, 1fr))',
            md: 'repeat(auto-fill, minmax(280px, 1fr))',
            lg: 'repeat(auto-fill, minmax(300px, 1fr))',
            xl: 'repeat(auto-fill, minmax(320px, 1fr))',
          },
          gap: 3,
          width: '100%',
        }}
      >
        {currentGenreData.shows.map(programme => (
          <Box key={programme.name}>
            <GridCard
              title={programme.name}
              imagePath={programme.show_image || 'thumb_generic_flux_news.png'}
              isAvailable={true}
              onClick={() => onProgrammeClick(programme)}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
